import React, { useEffect, useState } from "react";
import { Divider, Grid, styled } from "@mui/material";
import { FnAxios, RouterDOM } from "utilities/utilities";
import { ApiNavigation, ApiNavigationType } from 'enum/api';
import { IMenuItem } from "components/Layout/Menu/Layout1/MenuProps";
import { Link } from "react-router-dom";
import { IconComponents } from "components/Icon";

import ImageRecruit from "assets/images/Parallax/Icon/New Project (12).png";
import ImageHome from "assets/images/Parallax/Icon/New Project (13).png";
import ImageGallery from "assets/images/Parallax/Icon/New Project (15).png";
import ImageAboutUs from "assets/images/Parallax/Icon/New Project (16).png";
import ImageDashboard from "assets/images/Parallax/Icon/New Project (17).png";

import Tooltip from "@mui/material/Tooltip";

const MenuAll = () => {
    const AxiosFn = FnAxios();
    const Router = RouterDOM();
    const [arrDataMenu, setarrDataMenu] = useState<IMenuItem[]>([]);
    const [nMenu, setnMenu] = useState<any>(0);

    useEffect(() => {
        getDataMenu();
    }, [window.location.pathname]);

    const getDataMenu = () => {
        //1 = FrontendTop, 2 = FrontendLeft, 3 = Backend
        let result: IMenuItem[] = [];
        AxiosFn.Get(ApiNavigation.GetMenu, { nMenuType: ApiNavigationType.FrontEndLeft }, (d) => {
            result = d.objResult.lstMenu;
            setarrDataMenu([...result]);
            setnMenu(result.length);
        })
    };
    
    return (
        <div className="div-MenuList">
            <Grid item xs={12} md={12}>
                {arrDataMenu.filter(f => f.nMenuType == 2).map((item, index) => {
                    let sMenuID = "sMenu_" + item.nMenuID;
                    let isDivider = (nMenu === (index + 1)) ? true : false;
                    let isIcon = true;
                    let sImg = "";
                    switch (item.sRoute) {
                        case "/Home":
                            isIcon = false;
                            sImg = ImageHome;
                            break;
                        case "/ApplyMember":
                            isIcon = false;
                            sImg = ImageRecruit;
                            break;
                        case "/Dashboard":
                            isIcon = false;
                            sImg = ImageDashboard;
                            break;
                        case "/GalleryListImg":                      
                            isIcon = false;
                            sImg = ImageGallery;
                            break;
                        case "/AboutUs":
                            isIcon = false;
                            sImg = ImageAboutUs;
                            break;
                    }

                    let sRoute = Router.GetCurrentRoute();
                    let sPathName = sRoute.replace("/", "");
                    let sRouteName = item.sRoute.replace("/", "").toLocaleLowerCase();            

                    return (
                        <Grid item xs={12} md={12} key={sMenuID}>
                            <Grid item xs={12} md={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={12} md={12} style={{ padding: '7%', }} className={((item.sRoute === "/Home" && sPathName === "") || (item.sRoute === "/Project" && sPathName === "projectfrom") || (item.sRoute === "/GalleryListImg" && sPathName === "gallerydetail") || sPathName === sRouteName) ? "div-MenuAction" : "div-Menu"}>
                                <Tooltip 
                                    title={item.sMenuName} 
                                    placement="right" 
                                    arrow 
                                    componentsProps={{
                                        tooltip: {
                                            sx: {
                                                backgroundColor: '#fde8a8',
                                                color: 'black',
                                                fontSize: '14px',
                                                borderRadius: '8px',
                                                paddingBlock: '4%',
                                                '& .MuiTooltip-arrow': {
                                                    color: '#fde8a8',
                                                },
                                            },
                                        }
                                    }}
                                >
                                    <Link
                                        to={item.sRoute}
                                        preventScrollReset={true}
                                        style={{ textDecoration: 'none' }}
                                        onClick={() => {
                                            window.scrollTo({ top: 0, behavior: `smooth` });
                                        }}
                                    >
                                        {isIcon === true ? IconComponents(item.sIcon) : <img src={sImg} alt={item.sMenuName} />}
                                    </Link>
                                </Tooltip>
                            </Grid>
                            {isDivider &&
                                <Grid item xs={12} md={12}>
                                    <Divider />
                                </Grid>
                            }
                        </Grid>
                    )
                })
                }
            </Grid>
        </div >
    );
};
export default MenuAll;